// extracted by mini-css-extract-plugin
module.exports = {"header":"productCategory_header__10if4","table":"productCategory_table__1Fe8S"};